<template>
  <div class="status" :class="classes">
    <div class="status-light"></div>
    <span v-if="hasDefaultSlot"><slot /></span>
  </div>
</template>

<script>
export default {
  props: {
    online: Boolean
  },

  computed: {
    classes() {
      return {
        status_online: this.online,
        status_offline: !this.online
      };
    },

    hasDefaultSlot() {
      return this.$slots.default || this.$scopedSlots.default;
    }
  }
};
</script>

<style lang="scss">
.status {
  display: inline-flex;
  align-items: center;

  > span {
    margin-left: 4px;
  }

  &_online span {
    color: #27c400;
  }
  &_offline span {
    color: #e72f31;
  }

  &-light {
    display: inline-flex;
    align-items: center;
    max-width: 10px;
    width: 10px;
    height: 10px;
    max-height: 10px;
    border-radius: 100%;
    padding: 2px;

    &:before {
      content: " ";
      display: inline-flex;
      align-items: center;
      width: 6px;
      height: 6px;
      border-radius: inherit;
      animation: pulse 2s infinite;
    }

    .status_online & {
      color: #27c400;
      background: rgba(#27c400, 0.3);
      animation: pulse-online 2s infinite;

      &:before {
        background: #27c400;
      }
    }
    .status_offline & {
      color: #e72f31;
      background: rgba(#e72f31, 0.3);
      animation: pulse-offline 2s infinite;

      &:before {
        background: #e72f31;
      }
    }
  }
}
</style>
